import { Component, OnInit, ViewChild, ChangeDetectorRef, forwardRef, Input, ElementRef } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators, FormArray, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { AgentService } from '../../../../../app/front-user/services/e-booking/shared/services/agent.service';
import { LookupService } from '../../../../../app/front-user/shared/services/lookup.service';
import { GenericLookup } from '../../../../../app/front-user/shared/models/generic-lookup.model';
import { SmallUnitRequest } from '../shared/models/Small-Unit-Request.model';
import { fileService } from '../../../../../app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Attachment } from '../../../../../app/front-user/shared/models/attachment.model';
import { AttachmentType, Languages, FormMode, ServiceStatus, Service, SmallUnitReviewrDecision, SUMeasurementDecision, SUInvoiceImages } from '../../../../../app/shared/models/enums.model';
import { GlobalServices } from '../../../../../app/shared/services/global.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { SmallUnitsServiceFE } from '../shared/services/small-units.service';
import { ResponseObject } from '../../../../../app/shared/models/response-object.model';
import { AlertService } from '../../../../../app/shared/components/alert/alert.service';
import { User } from '../../../../../app/front-user/shared/models/user.model';
import { AuthenticationService } from '../../../../../app/front-user/shared/services/authentication.service';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRequest } from '../../../../../app/shared/models/base-request.model';
import { BaseRequestService } from '../../../../../app/front-user/shipyard-service/services/base-request.service';
import { FileValidator } from '../../../../../app/front-user/shared/validator/file-input.validator';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
import { Country } from '../../../../../app/front-user/shared/models/country.model';
import * as pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
import { SmallUnitService } from 'src/app/admin/e-services/small-units/shared/models/small-units-service.model';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-entrance-request',
  templateUrl: './entrance-request.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EntranceRequestComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EntranceRequestComponent),
      multi: true
    }
  ]
})

export class EntranceRequestComponent implements OnInit {
  EntranceRequest: SmallUnitRequest = new SmallUnitRequest();
  loading = false;
  @Input() IsAdminMode: boolean = false;
  @Input() public RequestStatus: number;
  @Input() public AgentId: string;
  TransitRequestNumber: string;
  hasTransit: boolean = false;
  moreInfomation: string;
  moreInfomation2: string;
  formSubmitted = false;
  showMoreInfo = false;
  showMoreInfo2 = false;
  private responseObj: ResponseObject = new ResponseObject();
  countries: Country[] = [];
  isLoaded: boolean = false;
  directions: SailDirection[] = [];
  isCompleted: boolean = false;
  todayDate: Date = new Date();
  ServiceStatus = ServiceStatus;
  nationalities: GenericLookup[] = [];
  RequestAttachments: Attachment[] = [];
  AttachmentType = AttachmentType.SmallUnits;
  currenctAttachment: Attachment = new Attachment();
  getAttachments: Attachment[] = [];
  shipType: string;
  agentId: string;
  loggedInUser: User = new User();
  today = new Date();
  user: User = new User();
  numberDecimalRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  numberRegex: any = /^[0-9]*$/;
  requestId: string;
  SelectedCurrencyId: number;
  showRequest = false;
  error: any = { isError: false, errorMessage: '' };
  errorLastTransit: any = { isError: false, errorMessage: '' };
  public Languages: any = Languages;
  entranceRequestForm: FormGroup;
  public FormMode: any = FormMode;
  formMode = FormMode.Add;
  baseRequestDTO: BaseRequest;
  isErrorMessage: boolean = false;
  isTabOneValid: boolean = false;
  isTabTwoValid: boolean = false;
  showPrintPdf: boolean = false;
  @ViewChild('EntranceRequest',{static: false}) entranceRequestEle: ElementRef;
  isTabOneSubmitted: boolean = false;
  showSubmit: boolean = false;
  AgentCurrencies: GenericLookup[] = [];

  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;
  uploadFolder = AppConfig.settings.apiServer.smallUnitsUploadsFolder;
  requestStatus: number;
  responseObject: ResponseObject;
  @ViewChild('entranceRequestTabs',{static: false}) entranceRequestTabs: TabsetComponent;
  @ViewChild('tabOneControls',{static: false}) tabOneControls: ElementRef;
  @ViewChild('tabTwoControls',{static: false}) tabTwoControls: ElementRef;
  displayedLang: any;
  SmallUnitServicesDTO: SmallUnitService[] = [];
  pdf_AgentName: string;
  pdf_AgentAccountNo: object;
  pdf_direction: string;
  getAgentCalled: boolean = false;
  constructor(private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private agentService: AgentService,
    private lookupService: LookupService, private fileService: fileService,
    private translate: TranslateService,
    private globalSrv: GlobalServices, private cd: ChangeDetectorRef,
    private _smallUnitsServiceFE: SmallUnitsServiceFE,
    private alertService: AlertService,
    private authSrevice: AuthenticationService, private route: ActivatedRoute,
    private baseRequestService: BaseRequestService, private router: Router) {


    this.displayedLang = this.globalSrv.getLanguage();
    this.loggedInUser = this.authSrevice.currentUserValue;
    if (localStorage.getItem('requestId') != undefined) {
      this.requestId = localStorage.getItem('requestId');
      localStorage.removeItem('requestId');
    }
    else if (history.state.data && history.state.data.requestId) {
      this.requestId = history.state.data.requestId;
    }
    else {
      //this.CheckCanApplyFees();
    }
    this.agentService.listen().subscribe((m: any) => {
      this.agentId = m;
    });
  }
  ngOnChanges() {
    // if (!this.agentId) {
    //   if (!this.loggedInUser.IsAdmin) {
    //     this.agentId = this.loggedInUser.UserId;
    //     this.getAgent(this.agentId);
    //   }
    // }
    console.log('Value changes:', this.entranceRequestForm.get('SelectedCurrencyId')?.value);
  }
  ngOnInit() {
    this.buildForm();
    // if (this.formMode == FormMode.Add) {
      this.getLookups();
    // }
    if (!this.loggedInUser.IsAdmin) {
      if (!this.agentId) {
        this.agentId = this.loggedInUser.UserId;
      }
      this.getAgent(this.agentId);
    }
    if (this.requestId) {
      this.getRequest();
    }

  }

  ngAfterViewInit() {
    if (this.entranceRequestTabs?.tabs?.length > 0) {
      this.entranceRequestTabs.tabs[0].disabled = true;
      this.entranceRequestTabs.tabs[1].disabled = true;
    }
  }

  public getRequest() {
    this.globalSrv.isLoaderEnabled = true;
    this._smallUnitsServiceFE.get(this.requestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {

          //this.SmallUnitServicesDTO=resObj.Data['SmallUnitServices'];
          this.EntranceRequest = resObj.Data;
          this.pdf_direction = resObj.Data.Direction.Direction;
          this.agentId = resObj.Data['RequestorId'];
          if (this.getAgentCalled == false){
            this.getAgent(this.agentId);
          }
          this.requestStatus = resObj.Data['StatusId'];
         // this.getbaseRequest();
          this.moreInfomation = resObj.Data['SmallUnitMoreInformation']
          this.moreInfomation2 = resObj.Data['MeasEstimationMoreInformation']
          this.isLoaded = true;
          // if (this.requestStatus == ServiceStatus.SmallUnit_RequestCompleted||
          //   (resObj.Data['FinalTotalFees'] != null && this.loggedInUser.IsAdmin)) {
          if ((this.requestStatus != ServiceStatus.SmallUnit_RequestPendingReview &&
            this.requestStatus != ServiceStatus.SmallUnit_MoreInformationRequestedFromAgent &&
            this.requestStatus != ServiceStatus.SmallUnit_PendingEstimateFees &&
            this.requestStatus != ServiceStatus.SmallUnit_PendingUnitArrival &&
            this.requestStatus != ServiceStatus.SmallUnit_PendingMeasuringUnit) ||
              (resObj.Data['FinalTotalFees'] != null && this.loggedInUser.IsAdmin )) {
            this.showPrintPdf = true;
          }
          else {
            this.showPrintPdf = false;
          }
          if (history.state.data && history.state.data.isCompleted) {
            this.entranceRequestForm.disable();
            this.formMode = FormMode.Readonly;
          }
          else if (this.requestStatus == ServiceStatus.SmallUnit_MoreInformationRequestedFromAgent && !this.loggedInUser.IsAdmin) {
            if (this.responseObj.Data["SmallUnitReviewActionId"] == SmallUnitReviewrDecision.MoreInformation && this.moreInfomation) {
              this.showMoreInfo = true;
              this.showMoreInfo2 = false;
            }
            if (this.responseObj.Data["MeasEstimationActionId"] == SUMeasurementDecision.MoreInformation && this.moreInfomation2) {
              this.showMoreInfo2 = true;
              this.showMoreInfo = false;
            }
            this.entranceRequestForm.enable();
            this.showSubmit = true;
            this.formMode = FormMode.Edit;
          }
          else {
            this.entranceRequestForm.disable();
            this.formMode = FormMode.Readonly;
          }
          if (this.formMode == FormMode.Readonly || this.formMode == FormMode.Edit) {
            this.entranceRequestTabs.tabs[0].disabled = false;
            this.entranceRequestTabs.tabs[1].disabled = false;
          }
          if (this.loggedInUser.IsAdmin && this.requestStatus == ServiceStatus.SmallUnit_RequestPendingReview && this.responseObj.Data["SmallUnitReviewActionId"] == SmallUnitReviewrDecision.MoreInformation && this.moreInfomation) {
            this.showMoreInfo = true;
            this.showMoreInfo2 = false;
          }
          if (this.loggedInUser.IsAdmin && this.requestStatus == ServiceStatus.SmallUnit_PendingEstimateFees && this.responseObj.Data["MeasEstimationActionId"] == SUMeasurementDecision.MoreInformation && this.moreInfomation2) {
            this.showMoreInfo2 = true;
            this.showMoreInfo = false;
          }
          //this.agentService.filter(this.agentId);
          this.RequestAttachments = resObj.Data['Attachments'];
          this.entranceRequestForm.setControl('Attachments', this.bindAttachments(this.RequestAttachments));
          resObj.Data['Attachments'] = [];
          this.entranceRequestForm.patchValue(resObj.Data);
          this.globalSrv.isLoaderEnabled = false;

          if (resObj.Data['TransitDate']) {
            this.entranceRequestForm.patchValue({
              TransitDate: new Date(resObj.Data['TransitDate']),
            });
          }
          if (resObj.Data['LastTransitDate']) {
            this.entranceRequestForm.patchValue({
              LastTransitDate: new Date(resObj.Data['LastTransitDate']),
            });
          }
          if (resObj.Data['ArrivalDate']) {
            this.entranceRequestForm.patchValue({
              TermsAndConditions: true,
              //GunsAndDrones:true,
              ETA: new Date(resObj.Data['ArrivalDate']),
              ETATime: new Date(resObj.Data['ArrivalDate']),
            });
          } else {
            this.entranceRequestForm.patchValue({
              TermsAndConditions: true,
              //GunsAndDrones:true,
            });
          }
        }
      });
  }
  compareLastTransit() {
    if (this.formMode != FormMode.Readonly) {

      if (this.entranceRequestForm.controls['LastTransitDate'].value == "Invalid Date") {
        this.entranceRequestForm.controls['LastTransitDate'].setErrors({ 'invalid': true });
      }
      else if ((this.entranceRequestForm.controls['ArrivalDate'].value && this.entranceRequestForm.controls['LastTransitDate'].value) &&
        ((new Date(this.entranceRequestForm.controls['ArrivalDate'].value) < new Date(this.entranceRequestForm.controls['LastTransitDate'].value)))) {
        this.errorLastTransit = { isError: true, errorMessage: this.translate.instant('FRONT_USER.FEES_ESTIMATION_FORM.COMPARE_LAST_TRANSIT_ERROR_smallUnits') };
        this.entranceRequestForm.controls['LastTransitDate'].setErrors({ 'invalid': true });
      }
      else {
        this.errorLastTransit = { isError: false, errorMessage: '' };
        this.entranceRequestForm.get('LastTransitDate').clearValidators();
        this.entranceRequestForm.get('LastTransitDate').updateValueAndValidity();
      }
    }
  }
  onSubmit() {

    const invalidElements = this.entranceRequestEle.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      if (!this.isTabOneValid) {
        invalidElements[0].focus();
        this.navigateToTab(0);
      }

      else if (!this.getValidity()) {
        invalidElements[0].focus();
        this.navigateToTab(1);

      }
    }
    this.formSubmitted = true;
    if (this.entranceRequestForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    if (this.entranceRequestForm.get("ArrivalDate").value) {
      var selectedLastDate = this.entranceRequestForm.get("ArrivalDate").value.toLocaleString('en-US');
      this.entranceRequestForm.controls['ArrivalDate'].setValue(selectedLastDate);
    }
    if (this.entranceRequestForm.get("LastTransitDate").value) {
      var selectedLastDate = this.entranceRequestForm.get("LastTransitDate").value.toLocaleString('en-US');
      this.entranceRequestForm.controls['LastTransitDate'].setValue(selectedLastDate);
    }
    this.SelectedCurrencyId = this.entranceRequestForm.get("SelectedCurrencyId").value;
    this.loading = true;
    this.EntranceRequest = this.entranceRequestForm.value;
    this.EntranceRequest.RequestorId = this.loggedInUser.UserId;
    // this.EntranceRequest.CreatedBy = this.authSrevice.currentUserValue.Email;
    // this.EntranceRequest.ModifiedBy = this.authSrevice.currentUserValue.Email;
    this.EntranceRequest.SelectedCurrencyId = this.SelectedCurrencyId;
    if (this.formMode == FormMode.Add) {
      this._smallUnitsServiceFE.SubmitEntranceRequest(this.EntranceRequest).pipe(first())
        .subscribe(
          (data: ResponseObject) => {

            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              this.entranceRequestForm.reset();
              this.loading = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              this.loading = false;
            }
          });
    }
    if (this.formMode == FormMode.Edit) {
      this.EntranceRequest.Id = this.requestId;
      this.getAttachments = this.entranceRequestForm.value.Attachments;
      this.getAttachments.forEach((form) => {
        this.RequestAttachments.forEach((db) => {
          if (form.Id == db.Id && form.URL == null) {
            form.URL = db.URL;
          }
        });
      });
      this._smallUnitsServiceFE.Update(this.EntranceRequest).pipe(first())
        .subscribe(
          (data: ResponseObject) => {

            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              this.entranceRequestForm.reset();
              this.loading = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              this.loading = false;
            }
          });
    }
    this.loading = false;
  }
  buildForm() {

    this.entranceRequestForm = this.formBuilder.group({
      UnitName: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
      RegisterNo: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
      //CrewNo: ['', [Validators.required, Validators.pattern("^([0-9]|[1-9][0-9]|1000)$")]],
      CrewNo: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
      NationalityId: ['', Validators.required],
      ArrivalDate: ['', [Validators.required]],
      DirectionId: ['', Validators.required],
      Length: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      Width: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      Depth: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      LastTransitDate: [''],
      FromCountryId: ['', [Validators.required]],
      ToCountryId: ['', [Validators.required]],
      UnitTypeId: ['', [Validators.required]],
      NetTonnage: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), Validators.max(299.99)]],
      GrossTonnage: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), Validators.max(299.99)]],
      SCNetTonnage: ['', [Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), Validators.max(299.99)]],
      SCGrossTonnage: ['', [Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), Validators.max(299.99)]],
      TermsAndConditions: [false, [Validators.requiredTrue]],
      //GunsAndDrones: [false, [Validators.requiredTrue]],
      SelectedCurrencyId: ['', Validators.required],
      Attachments: this.formBuilder.array([]),
    });
    if (!this.requestId) {
      this.addAttachments();
    }
  }
  get f() {
    return this.entranceRequestForm.controls;
  }

  public getAgent(agentId: string) {
    this.getAgentCalled = true; // This flag is set to true to prevent a second call of getAgent inside getRequest()
    this.agentService.GetAgent(agentId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObject = resObj;
        if (this.responseObject.Success) {
          this.pdf_AgentName = resObj.Data.Name;
          if (!resObj.Data.IsOffline) {
            resObj.Data.AgentCurrencies = resObj.Data.AgentCurrencies.filter(item => item.TreasuryNumber != null);
          }
          this.AgentCurrencies = resObj.Data['AgentCurrencies'].map(function (obj) {
            return {
              Id: obj.Currency.Id,
              NameEN: obj.Currency.NameEN + "-" + obj.TreasuryNumber,
              NameAR: obj.Currency.NameAR + "-" + obj.TreasuryNumber,
              //TreasuryNumber added to be displayed in the invoice -- by mohamed ibrahim
              TreasuryNumber: obj.TreasuryNumber
            }

          });
          // if (this.FormMode != FormMode.Add && this.SelectedCurrencyId) {
          //   this.entranceRequestForm.patchValue({
          //     SelectedCurrencyId: this.SelectedCurrencyId
          //   });
          // }
        }
      });
  }

  selectTab(tabId: number) {
    if (tabId == 1) {
      this.isTabOneSubmitted = true;
      if (!this.ValidateTabOne) {
        this.isTabOneValid = true;
        this.entranceRequestTabs.tabs[0].disabled = false;
        this.entranceRequestTabs.tabs[1].disabled = false;
        this.entranceRequestTabs.tabs[tabId].active = true;
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      } else {
        const invalidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
      }
    }
    else {
      this.entranceRequestTabs.tabs[0].disabled = false;
      this.entranceRequestTabs.tabs[1].disabled = false;
      this.entranceRequestTabs.tabs[tabId].active = true;
    }
  }

  private getLookups() {

    this.lookupService.getCountries().subscribe(
      data => this.countries = data.Data as Country[],
    );
    this.lookupService.getSailDirections().subscribe(d => {
      if (d.Data) {
        this.directions = d.Data;
      }
    });
    this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data.filter(p => p.IsDeleted == false);
    });
  }
  get Attachments() {
    return this.entranceRequestForm.get('Attachments') as FormArray;
  }
  get attachment(): FormGroup {
    return this.formBuilder.group({
      DocumentName: '',
      URL: '',
      AttachmentTypeId: ''
    });
  }
  deleteAttachments(index: number, progressVariableName) {
    this[progressVariableName] = 0;
    this.Attachments.removeAt(index);
    this.RequestAttachments.splice(index, 1);
  }
  bindAttachments(attachments): any {
    let control = <FormArray>this.entranceRequestForm.controls['Attachments'];
    if (this.requestStatus == ServiceStatus.SmallUnit_MoreInformationRequestedFromAgent && !this.loggedInUser.IsAdmin) {
      attachments.forEach((key) => {
        control.push(new FormGroup({
          DocumentName: new FormControl({ value: key.DocumentName, disabled: false }),
          URL: new FormControl(),
          AttachmentTypeId: new FormControl({ value: key.AttachmentTypeId, disabled: false }),
          Id: new FormControl({ value: key.Id, disabled: false }),
        }));
      });
    }
    else {
      attachments.forEach((key) => {
        control.push(new FormGroup({
          DocumentName: new FormControl({ value: key.DocumentName, disabled: true }),
          URL: new FormControl(),
          AttachmentTypeId: new FormControl({ value: key.AttachmentTypeId, disabled: false }),
          Id: new FormControl({ value: key.Id, disabled: false })
        }));
      });
    }
    return control;
  }

  getCurrentAttchment(index) {
    if (this.RequestAttachments.length > 0) {
      this.currenctAttachment = this.RequestAttachments[index];
    }
  }

  public onFileSelected(event, currFormControl, index, progressVariableName) {
    this[progressVariableName] = 0;
    let percentDone = 0;
    this.alertService.clear();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });
    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      let donName = file.name.split('.').slice(0, -1).join('.')
      formData.append('DocumentName', donName);
      formData.append('FolderName', this.uploadFolder);
      this.fileService.fileUploader(formData).subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            percentDone = Math.round(100 * event.loaded / event.total)
            this[progressVariableName] = percentDone;
            currFormControl.setErrors({ notCompleted: true });
          } else if (event instanceof HttpResponse) {
            var jsonResponse = event.body.Data;
            var Url = jsonResponse.Url;
            currFormControl.setValue(Url);
            currFormControl.setErrors(null);
            currFormControl.updateValueAndValidity();
          }
        }
      );
    }
  }

  get getAttachmentsGetter() {
    return this.entranceRequestForm.controls["Attachments"].value;
  }

  get getAttachmentsLengthGetter() {
    return this.getAttachmentsGetter.length;
  }
  CheckCanApplyFees() {
    this.agentService.CanApplyFeesRequest(this.loggedInUser.UserName).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          if (!data.Success) {
            this.router.navigate(['/unAuhtorized']);
          }
        });
  }
  addAttachments() {
    let control = <FormArray>this.entranceRequestForm.controls['Attachments'];
    control.push(new FormGroup({
      DocumentName: new FormControl('', Validators.required),
      URL: new FormControl('', FileValidator.validate),
      AttachmentTypeId: new FormControl(''),
      Id: new FormControl('')
    }));
    return control;
  }
  get ValidateTabOne() {
    const isvalid = this.entranceRequestForm.controls['UnitName'].invalid
      || this.entranceRequestForm.controls['RegisterNo'].invalid
      || this.entranceRequestForm.controls['CrewNo'].invalid
      || this.entranceRequestForm.controls['NationalityId'].invalid
      || this.entranceRequestForm.controls['ArrivalDate'].invalid
      || this.entranceRequestForm.controls['DirectionId'].value == 'null'
      || this.entranceRequestForm.controls['SelectedCurrencyId'].value == 'null'
      || this.entranceRequestForm.controls['Length'].invalid
      || this.entranceRequestForm.controls['Width'].invalid
      || this.entranceRequestForm.controls['Depth'].invalid
      || this.entranceRequestForm.controls['LastTransitDate'].invalid
      || this.entranceRequestForm.controls['FromCountryId'].invalid
      || this.entranceRequestForm.controls['ToCountryId'].invalid
      || this.entranceRequestForm.controls['UnitTypeId'].invalid
      || this.entranceRequestForm.controls['NetTonnage'].invalid
      || this.entranceRequestForm.controls['GrossTonnage'].invalid
      || this.entranceRequestForm.controls['SCNetTonnage'].invalid
      || this.entranceRequestForm.controls['SCGrossTonnage'].invalid;
    if (isvalid) {
      this.isTabOneValid = false;
    }
    else {
      this.isTabOneValid = true;
    }
    return isvalid;
  }
  getValidity() {
    let controls = this.entranceRequestForm.get('Attachments') as FormArray;
    let Termscontrol = this.entranceRequestForm.get('TermsAndConditions')
    // let GunsAndDrones = this.entranceRequestForm.get('GunsAndDrones')
    // if(!controls.invalid && !Termscontrol.invalid && !GunsAndDrones.invalid){
    if (!controls.invalid && !Termscontrol.invalid) {
      return !controls.invalid;
    }
  }
  goToTermsAndCond(): void {
    if (this.displayedLang == Languages.Arabic)
      window.open(AppConfig.settings.apiServer.SmallUnitsTermsAR, '_blank');
    else
      window.open(AppConfig.settings.apiServer.SmallUnitsTermsEN, '_blank');
  }
  public getbaseRequest() {
    this.baseRequestService.getBaseRequest(this.requestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.baseRequestService.GetByParentRequestId(this.requestId, Service.SmallUnits).subscribe(
          d => {

          });

      });
  }
  get validateSubmitButton() {
    if (this.isTabOneValid) {
      if (this.entranceRequestTabs.tabs[1].disabled == false &&
        this.entranceRequestTabs.tabs[1].active == true) {
        this.showSubmit = true;
      }

    }
    return this.showSubmit;
  }
  navigateToTab(tabId: number) {
    this.entranceRequestTabs.tabs[tabId].disabled = false;
    this.entranceRequestTabs.tabs[tabId].active = true;
  }
  exportapdf(e): void {
    e.preventDefault();
    this.exportDataTOpdf();
  }
  exportDataTOpdf(): void {
    let Header = SUInvoiceImages.Header1;
    let Footer = SUInvoiceImages.Footer;
    let Background = SUInvoiceImages.Background2;
    let invoiceno = this.EntranceRequest.InvoiceNo;
    let yachtname = this.EntranceRequest.UnitName;
    let agentname = this.pdf_AgentName;
    this.pdf_AgentAccountNo = this.AgentCurrencies.filter(x => x.Id == this.entranceRequestForm.get('SelectedCurrencyId').value);
    let AgentAccountNo = this.pdf_AgentAccountNo[0].TreasuryNumber;
    let transitfees = this.EntranceRequest.FinalTransitFeesValue;
    let totalfees$ = this.EntranceRequest.FinalTotalFees;
    let totalfeesLE = this.EntranceRequest.TotalFeesLE;
    let SDRrate = this.EntranceRequest.FinalSDR;
    let localequiv = this.EntranceRequest.LocalEquiv;
    let direction = this.pdf_direction == "Northbound" ? "Suez" : "Portsaid";
    let transitdate = this.datepipe.transform(this.EntranceRequest?.SmallUnitConfirmTransitDate?.split("T")[0], 'dd/MM/yyyy');
    let nettonnage = this.EntranceRequest.ActualSCNT;
    //let invoicedate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    let invoicedate = this.datepipe.transform(this.EntranceRequest?.InvoiceDate?.split("T")[0], 'dd/MM/yyyy');
    let invoiceAccontantName = this.EntranceRequest.InvoiceAccountantName;
    var Services = [];
    var ServicesHeader =[];
    var Signature = [];
    let InvoiceAuditorName = this.EntranceRequest.InvoiceAuditorName;
    let AuditorName = '';
    var Portsaid_Accountantchief = '';
    var Suez_Accountantchief = '';
    //-----------message for discount 50% from jul to oct 2024-------------
    var meassage_discount_50_percent = [];
     let sdt1 = '2024-07-01T00:00:00';
     let disdt1 = Date.parse(sdt1);
     let sdt2 = '2024-10-01T00:00:00';
     let disdt2  = Date.parse(sdt2);
     if(Date.parse(this.EntranceRequest.SmallUnitConfirmTransitDate) >= disdt1 &&
        Date.parse(this.EntranceRequest.SmallUnitConfirmTransitDate) <= disdt2 ){

       this.translate.get('ADMIN_USER.SmallUnits.meassage_discount_50_percent').subscribe((res: string) => {
      meassage_discount_50_percent = [{ text: res, style: 'Discount_50', width: 50, alignment: 'center' }] ;
      //return true;
       });

     }

  //--------------------------
    this.translate.get('ADMIN_USER.SmallUnits.PORTSAID_ACCOUNTANTCHIEF').subscribe((res: string) => {
      Portsaid_Accountantchief = res;
      //return true;
    });
    this.translate.get('ADMIN_USER.SmallUnits.SUEZ_ACCOUNTANTCHIEF').subscribe((res: string) => {
      Suez_Accountantchief = res;
      //return true;
    });
    ServicesHeader =
    [
      {
        columns: [
          { text: 'Item', style: 'tableHeader', width: 50, alignment: 'center' },
          { text: 'Date', style: 'tableHeader', width: 150, alignment: 'center' },
          { text: '', style: 'tableHeader', width: 200, alignment: 'center' },
          { text: '', style: 'tableHeader', width: 50, alignment: 'center' },
          { text: 'Value/$', style: 'tableHeader', width: 50, alignment: 'center' }
        ]
      }
    ];

    if(this.EntranceRequest.SmallUnitServices.length > 0){


      this.EntranceRequest.SmallUnitServices.forEach(element => {
        let service =
          [
            {
              columns: [
                {
                  text: element.ServiceName,
                  width: 55,
                  alignment: 'center'
                },
                {
                  text: this.datepipe.transform(element.ServiceDate, 'dd/MM/yyyy H:mm') + " GMT+2",
                  width: 150,
                  alignment: 'center'
                },
                {
                  text: element.ServiceDesc,
                  width: 200,
                  alignment: 'center'
                },
                {
                  text: element.ServiceDayNight,
                  width: 50,
                  alignment: 'center'
                },
                {
                  text: element.ServiceValue,
                  width: 50,
                  alignment: 'center'
                }
              ],
            },
            { text: '_____________________________________________________________________________________________' },
            { text: '\n' }

          ]
        Services.push(service);
      });
    }
    //Signature
    //---------
    if (this.loggedInUser.IsAdmin) {
      AuditorName = 'Auditor Name: ' + InvoiceAuditorName;
      //Northbound direction
      if(this.EntranceRequest.DirectionId == 2){
        Signature =
        [
          {
            columns: [
              {
                text: 'CHIEF OF ACCOUNTS \n', style: 'Bold',
              },
              {
                text: 'ACCOUNTANT  \n', style: 'Bold',
              }
            ]
          },
          {
            columns: [
              {
                text: '\n\n (ACC\\'+ Suez_Accountantchief +')',
              },
              {
                text: '\n\n' + invoiceAccontantName,
              },
            ]
          }
        ]
      }
      //Southbound direction
      else if(this.EntranceRequest.DirectionId == 3){
        Signature =
        [
          {
            columns: [
              {
                text: 'CHIEF OF ACCOUNTS \n', style: 'Bold',
              },
              {
                text: 'ACCOUNTANT  \n', style: 'Bold',
              }
            ]
          },
          {
            columns: [
              {
                text: '\n\n (ACC\\'+ Portsaid_Accountantchief +')',
              },
              {
                text: '\n\n' + invoiceAccontantName,
              },
            ]
          }
        ]
      }
    }

    let docDefinition = {
      // a string or { width: number, height: number }
      pageSize: 'A4',

      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'portrait',

      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      //pageMargins: [ 0, 0, 0, 0 ],

      /*  header: function(currentPage, pageCount, pageSize) {
         return [
           {
               image: Header,
               opacity: 0.9,
               fit: [1200, 100]
           },
         ]
       }, */
      background: function (currentPage, pageCount, pageSize) {
        return [
          {
            image: Background,
            //height: 845,
            //width:600,
            opacity: 0.9,
            fit: [600, 845]
          },
        ]
      },
      //watermark: { text: 'test watermark', color: 'blue', opacity: 0.3, bold: true, italics: false },
      /*    footer: function(currentPage, pageCount, pageSize) {
           return [
             {
                 image: Footer,
                 //height: 100,
                 opacity: 0.9
             },
           ]
         }, */

      content: [
        /*  { text: '\n\n\n\n\n' },
         { text: 'ARAB REPUBLIC OF EGYPT', style: 'center' },
         { text: 'SUEZ CANAL AUTHORITY \n \n', style: 'center' },
         { text: 'PORT SAID TRANSIT DEPARTMENT', style: 'center' },
         { text: '==============================================================================', }, */
        { text: '\n \n', style: 'center' },
        {
          columns: [
            { text: '', width: '*', alignment: 'left' ,
            },
            { text: 'YACHT\'s DETAILED STATEMENT OF TRANSIT DUES AND SERVICES', style: 'MainTitle', width: 280, alignment: 'right' },
          ]
        },

        { text: '\n \n', style: 'center' },
        //direction - date - invoice no
        {
          alignment: 'justify',
          columns: [
            {
              text: direction + ' , ' + invoicedate,
              style: 'Bold',
              alignment: 'left'
            },
            {
              text: 'Invoice/B : ' + invoiceno,
              style: 'Invoiceno',
              alignment: 'right'
            }
          ]
        },

        { text: '\n \n', style: 'center' },
        {
          text: [
            { text: 'To be collected from: ',
             },
            { text: agentname, style: 'Bold' },
            { text: '     ', style: 'Bold' },
            { text: 'Account No: ',
            },
            { text: AgentAccountNo, style: 'Bold' },
          ]
        },
        { text: '\n',
         },
        {
          text: [
            { text: 'For:SC transit tolls for the yacht (',
             },
            { text: yachtname, style: 'Bold' },
            { text: ') - ',
             },
            { text: this.pdf_direction, style: 'Bold' },
            { text: ' on ',
             },
            { text: transitdate, style: 'Bold' },
            { text: ' with net tonnage (',
             },
            { text: nettonnage, style: 'Bold' },
            { text: ')  ',
             },
            { text: 'Ton', style: 'Bold' },
          ]
        },
        { text: '\n\n',
         },
        ServicesHeader,
        { text: '\n\n',
         },
        Services,
        { text: '\n',
         },
        //Transit Dues
        {
          columns: [
            {
              text: 'Transit Dues  ',
              width: 100,
              alignment: 'center',
              style: 'Bold'
            },
            {
              text: '',
              width: 100,
              alignment: 'center',
              
            },
            {
              text: '',
              width: 200,
              alignment: 'center',
              
            },
            {
              text: '',
              width: 50,
              alignment: 'center',
              
            },
            {
              text: transitfees,
              width: 50,
              alignment: 'center',
              
            }
          ],
        },
        { text: '_____________________________________________________________________________________________' ,
        },
        { text: '\n',
         },
       /*  {
          columns: [
            { text: 'Transit Dues:  ', width: '*', style: 'Bold', alignment: 'right' },
            { text: transitfees, width: 50, style: 'Bold', alignment: 'center' },
          ]
        }, */
        {
          text: '\n'
        },
        // LOCAL EQUIV:
        {
          columns: [
            { text: 'LOCAL EQUIV: ' + localequiv, style: 'Bold' },
          ]
        },
        { text: '\n'
         },
        // Total
        {
          columns: [
            {
              text: 'Total LE:  ',
              width: 100,
              alignment: 'center',
              style: 'Bold'
            },
            {
              text: totalfeesLE ,
              width: 150,
              alignment: 'left',
              style: 'Bold'
            },
            {
              text: 'Total $:  ',
              width: 200,
              alignment: 'right',
              style: 'Bold'
            },
             {
              text: totalfees$,
              width: 50,
              alignment: 'center',
              style: 'Bold'
            },
            //{ text: 'Total LE:  ' + totalfeesLE + ' TON', style: 'Bold' },
            //{ text: 'Total:  ', width: '*', style: 'Bold', alignment: 'right' },
            //{ text: totalfees$, width: 50, style: 'Bold', alignment: 'center' },
          ]
        },
        { text: '\n\n'
        },
        { text: AuditorName},
        { text: '\n\n' 
        },
        Signature,
        {
          text: '\n\n'
        },
        meassage_discount_50_percent
      ],
      styles: {
        BOLDCenter: {
          alignment: "center",
          bold: true
        },
        MainTitle: {
          alignment: "right",
          fontSize: 18,
          bold: true,
          color: '#26537a'
        },

        Bold: {
          bold: true,
        },
        Bold2: {
          bold: true
        },

        right: {
          alignment: "right"
        },
        img: {
          alignment: "right"
        },
        img2: {
          alignment: "left"
        },
        center: {
          alignment: "center"
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        tableExample: {
          margin: [0, 5, 0, 15],
          fontSize: 12,
          alignment: 'left'
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black',
          decoration:'underline'
        },
        Discount_50: {
          italics: true,
          fontSize: 13,
          color: 'red',
          decoration:'underline'
        }
      }
    }
    pdfMake.fonts = {
      Arial: {
        normal: 'Arial-Regular.ttf',
        bold: 'Arial-Regular.ttf',
        italics: 'Arial-Regular.ttf',
        bolditalics: 'Arial-Regular.ttf'
      }
    },
    pdfMake.createPdf(docDefinition).open();
  }
}
